/** Teams team where the Book bot should be installed for staff notifications. */
export function staffTeamsChannelName(): string {
  const env = (import.meta.env.VITE_APP_ENV ?? "").toLowerCase();
  if (env === "production" || env === "prod") return "Book";
  if (env === "nonprod") return "NonProd Apps";
  return "the staff Teams channel for this environment";
}
